const otherCarrier = '6';

export const whiteListedCarriers = [otherCarrier];
